<script>
import BaseResource from '../resources'
import ImageResource from '../resources/image'

export default {
    components: {},
    data() {
        return {
            loading: true,
            imageResource: null
        }
    },
    watch: {
        resource() {
            this.generate()
        }
    },
    props: {
        resource: {
            type: BaseResource,
            required: false
        },
        size: {
            required: false,
            default: '4em'
        },
        variant: {
            default: 'secondary'
        },
        icon: {
            default: 'person'
        },
        rounded: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        async generate() {
            this.loading = true
            
            if(this.resource instanceof ImageResource) {
                this.imageResource = this.resource
            } else if(this.resource && this.resource.get('image')) {
                this.imageResource = await this.resource.rel('image').resolve()
            }

            this.loading = false
        }
    },
    mounted() {
        this.generate()
    }
}
</script>

<template>
    <b-avatar
        :rounded="rounded"
        :variant="variant"
        :size="size"
        :icon="loading ? 'three-dots' : icon"
        :src="String(imageResource) || ''">
        <slot />
    </b-avatar>
</template>

<style lang="scss" scoped>

</style>
